import type { CPU } from '../CPU';
import { zsCheck } from './arithmetic';
import { H_ST, H_IA } from './constants';

export function opLS_EA(cpu: CPU): void {
  loadStore(cpu, cpu.regs.ea, cpu.impl_hint >> 8);
}

export function opLS_R(cpu: CPU): void {
  loadStore(cpu, cpu.impl_operands[1].value, cpu.impl_hint >> 8);
}

export function opLS_I_R(cpu: CPU): void {
  loadStore(cpu, cpu.impl_operands[1].value + cpu.impl_long_imm, cpu.impl_hint >> 8);
}

export function opLS_BP(cpu: CPU): void {
  let disp = cpu.impl_operands[1].value;
  disp |= (disp & 0x20) ? 0xFFC0 : 0;
  disp += cpu.regs.r[12] | (cpu.regs.r[13] << 8);
  loadStore(cpu, disp, cpu.impl_hint >> 8);
}

export function opLS_FP(cpu: CPU): void {
  let disp = cpu.impl_operands[1].value;
  disp |= (disp & 0x20) ? 0xFFC0 : 0;
  disp += cpu.regs.r[14] | (cpu.regs.r[15] << 8);
  loadStore(cpu, disp, cpu.impl_hint >> 8);
}

export function opLS_I(cpu: CPU): void {
  loadStore(cpu, cpu.impl_long_imm, cpu.impl_hint >> 8);
}

export function loadStore(cpu: CPU, offset: number, length: number): void {
  if (length % 2 === 0)
    offset &= ~1;
  const reg_base = cpu.impl_operands[0].value;
  const dataAddr = ((cpu.regs.dsr << 16) | (offset & 0xFFFF)) >>> 0;

  if (cpu.impl_hint & H_ST) {
    for (let ix = length - 1; ix >= 0; --ix)
      cpu.mmu.write8((dataAddr + ix) >>> 0, cpu.regs.r[reg_base + ix]);
  } else {
    for (let ix = 0; ix < length; ++ix) {
      cpu.impl_operands[0].value = cpu.mmu.read8((dataAddr + ix) >>> 0);
      zsCheck(cpu);
      cpu.regs.r[reg_base + ix] = cpu.impl_operands[0].value;
    }
  }

  if (cpu.impl_hint & H_IA)
    bumpEA(cpu, length);
}

export function bumpEA(cpu: CPU, value_size: number): void {
  cpu.regs.ea += value_size;
  if (value_size !== 1)
    cpu.regs.ea &= ~1;
}
